import { RouteProps, useResolvedPath } from '@rocketlane/rocket-router';
import { UseWithAccess, useWithAccess } from 'hooks/rbac/useWithAccess';
import { NotFound } from './404';
import { CustomSecureRoute } from './custom-secure-route';

export type PermissionRouteProps = RouteProps & UseWithAccess;

export type PermissionRoutePropsAlt = UseWithAccess;
export const SecureRoute = (props: PermissionRoutePropsAlt) => {
  const { rule, resourceData, ...rest } = props;
  const { hasAccessToResource, isLoading } = useWithAccess();
  const path = useResolvedPath('.');

  return rule == null ||
    hasAccessToResource({
      rule,
      resourceData,
    }) ? (
    <CustomSecureRoute
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      path={path.pathname}
      isLoading={isLoading}
    />
  ) : (
    <NotFound />
  );
};
